export default {
  // 面包屑
  projectList: 'Project List',
  deviceList: 'Device List',

  // 按钮
  addButton: 'Add',
  enterButton: 'Enter',
  detailButton: 'Detail',
  firmwareButton: 'Firmware',
  deleteButton: 'Delete',

  // 表格列标题
  projectNameColumn: 'Project Name',
  deviceNameColumn: 'Device Name',
  deviceSnColumn: 'Device SN',
  firmwareVersionColumn: 'Firmware Version',
  statusColumn: 'Status',
  actionColumn: 'Action',
  videoStreamColumn: 'Video Stream',

  // 状态
  online: 'Online',
  offline: 'Offline',

  // 确认对话框
  deleteConfirmTitle: 'Are you sure to delete?',
  confirmButton: 'Confirm',
  cancelButton: 'Cancel',

  // 加载提示
  loading: 'Loading...',

  // Tab标签
  airportTab: 'Airport',
  aircraftTab: 'Aircraft',

  // 成功消息
  deleteSuccess: 'Deleted successfully',
}
